import { FormattedMessage } from '@subaio/components'

import { asContainer } from 'lib/container'

import { HeaderIconUnauthenticated } from 'components/Icons'
import { SplashScreen } from 'components/Layout'

export const container = asContainer<{}>()({
	authentication: { type: 'public' },
	Running: () => (
		<SplashScreen
			title={<FormattedMessage id='notAuthorized.title' defaultMessage='You do not have access to this page' />}
			icon={<HeaderIconUnauthenticated />}
		/>
	),
})
